(function () {
  function getEventTarget(event, selector) {
    if (typeof event.composedPath === "function") {
      for (const node of event.composedPath()) {
        if (!(node instanceof Element)) continue;
        if (node.matches(selector)) return node;
        const closest = node.closest(selector);
        if (closest) return closest;
      }
    }

    return event.target instanceof Element ? event.target.closest(selector) : null;
  }

  function getSwitchRoot(trigger) {
    const header = trigger.closest(".size-chart__header");
    return header ? header.parentElement : null;
  }

  function setUnitTables(root, unit) {
    if (!root) return;

    root.querySelectorAll(".size-chart__header-item").forEach((item) => {
      const isInch = item.classList.contains("inch");
      const isCm = item.classList.contains("cm");
      item.classList.toggle(
        "toggle--active",
        (unit === "in" && isInch) || (unit === "cm" && isCm)
      );
    });

    root.querySelectorAll(".size-chart_table").forEach((table) => {
      const show =
        (unit === "in" && table.classList.contains("inch")) ||
        (unit === "cm" && table.classList.contains("cm"));

      table.classList.toggle("active", show);
      if (show) {
        table.removeAttribute("hidden");
      } else {
        table.setAttribute("hidden", "");
      }
    });
  }

  function initSwitchRoots() {
    document.querySelectorAll(".size-chart__header").forEach((header) => {
      const root = header.parentElement;
      if (!root || root.dataset.sizeUnitReady === "true") return;

      root.dataset.sizeUnitReady = "true";
      const active = header.querySelector(
        ".size-chart__header-item.toggle--active"
      );
      const unit = active?.classList.contains("cm") ? "cm" : "in";
      setUnitTables(root, unit);
    });
  }

  function onToggleHeaderClick(header) {
    const toggleRoot = header.closest(".toggle");
    const scope = toggleRoot || document;

    scope.querySelectorAll(".toggle-header").forEach((item) => {
      if (item !== header) item.classList.remove("active");
    });
    header.classList.toggle("active");
  }

  function onTabHeaderClick(tab) {
    const section =
      tab.closest(".help-sizegude__content, .toggle-content") || document;

    section.querySelectorAll(".sizeguide-tab-header").forEach((item) => {
      if (item !== tab) item.classList.remove("tab-active");
    });
    tab.classList.toggle("tab-active");

    const brand = tab.dataset.brand;
    const department = tab.dataset.department;
    if (!brand || !department) return;

    const panelsRoot = tab.closest(".toggle-content") || section;
    const targetId = `tab-${brand}-${department}`;

    panelsRoot.querySelectorAll(`.tab-content__panel.${brand}`).forEach((panel) => {
      panel.classList.toggle("toggle--active", panel.id === targetId);
    });
  }

  function bindGlobals() {
    window.toggleSizechartTable = function (val, triggerEl) {
      const root = triggerEl
        ? getSwitchRoot(triggerEl)
        : document.querySelector(".help-sizeguide--chart, .tab-content__panel");
      setUnitTables(root, val === "cm" ? "cm" : "in");
    };
  }

  function handleDocumentClick(event) {
    const header = getEventTarget(event, ".toggle-header");
    if (header) {
      event.stopPropagation();
      onToggleHeaderClick(header);
      return;
    }

    const tab = getEventTarget(event, ".sizeguide-tab-header");
    if (tab) {
      event.stopPropagation();
      onTabHeaderClick(tab);
      return;
    }

    const item = getEventTarget(event, ".size-chart__header-item");
    if (!item) return;
    if (!item.classList.contains("inch") && !item.classList.contains("cm")) {
      return;
    }

    event.stopPropagation();
    setUnitTables(
      getSwitchRoot(item),
      item.classList.contains("cm") ? "cm" : "in"
    );
  }

  if (window.__sizeGuideClickHandler) {
    document.removeEventListener("click", window.__sizeGuideClickHandler, true);
  }
  window.__sizeGuideClickHandler = handleDocumentClick;
  document.addEventListener("click", handleDocumentClick, true);
  bindGlobals();

  if (!window.__sizeGuideDialogInit) {
    window.__sizeGuideDialogInit = true;
    document.addEventListener(
      "dialog:after-show",
      () => {
        initSwitchRoots();
        bindGlobals();
      },
      true
    );
  }

  if (document.readyState === "loading") {
    if (!window.__sizeGuideDomReady) {
      window.__sizeGuideDomReady = true;
      document.addEventListener("DOMContentLoaded", initSwitchRoots);
    }
  } else {
    initSwitchRoots();
  }
})();
